import React, { Component } from 'react';
import _ from 'underscore';

const style = {
    container: {
        backgroundColor: "rgba(9, 11, 20, 0.95)",
        position: "absolute",
        zIndex: 20,
        top: 0,
        right: 0,
        left: 0,
        bottom: 0
    },

    itemTag: {
        display: 'inline-block',
        color: 'white',
        padding: '10px 15px',
        margin: 5,
        border: '1px white solid',
        borderRadius: 5
    },

    selectedItem: {
        display: 'inline-block',
        backgroundColor: 'orange',
        color: 'black',
        padding: '10px 15px',
        margin: 5,
        border: '1px white solid',
        borderRadius: 5
    }
};

let selectedOptions = {};

export class OptionSelector extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.selectItem = this.selectItem.bind(this);
    }
    selectItem(item) {
        console.log('selectecd item', item);

        if(this.state[item.id]) {
            delete this.state[item.id];

        } else {
            if(_.values(this.state).length >= this.props.option.quantity) {
                alert(this.props.option.name + '类只能选择' + this.props.option.quantity + "项餐品");
                return;
            }

            this.state[item.id] = item;
        }

        this.setState(this.state);
        this.props.onChange(_.values(this.state));
    }

    render() {
        const {option} = this.props;

        return (
            <div className="tags">
                <div className="tag-title">
                    <div className="tag-icon">
                        <span style={{color: 'orange', marginLeft: 10}}>{option.name}</span>
                    </div>
                </div>
                {option.options.map(o =>
                    <span style={this.state[o.id] ? style.selectedItem : style.itemTag}
                          onClick={() => this.selectItem(o)}
                          key={o.id}
                          value={JSON.stringify(o)}
                    >
                        {o.name}
                    </span>)}
            </div>
        );
    }
}

export default class PackgeBuilder extends Component {
    selectOption(option, selectedItems) {
        console.log("option selected!", option, selectedItems);
        selectedOptions[option.name] = selectedItems;
        console.log('selected options are ', selectedOptions);
    }

    confirmOptions() {
        console.log('validate selected options', selectedOptions);
        const {packageSpec} = this.props;
        let confirmFlag = true;
        let errorMsg = null;

        packageSpec.items.forEach(option => {
            const items = selectedOptions[option.name];

            if(option.quantity>1) {
                console.log('check option with multiple selection ', option);

                if(items.length === option.quantity) {
                    if(!option.canRepeat) {
                        console.log('check for repeated items', items, _.uniq(_.map(items, i => i.id)));

                        if(_.uniq(_.map(items, i => i.id)).length !== option.quantity) {
                            errorMsg = option.name + "类餐品不可重复";
                            confirmFlag = false;
                            return false;
                        }
                    }
                } else {
                    confirmFlag = false;
                    errorMsg = option.name + "需选择" + option.quantity + "样餐品";
                }
            } else {
                if(!items || items.length<1) {
                    errorMsg = "请选择" + option.name;
                    confirmFlag = false;
                }
            }
        });

        if(errorMsg) {
            alert(errorMsg);

        } else if(confirmFlag){
            this.props.onConfirm(selectedOptions);
        }
    }

    render() {
        console.log("rendering package builder ", this.props);
        const {packageSpec} = this.props;
        selectedOptions = {};
        const items = packageSpec.items.map(item => {
            return (<OptionSelector option={item} onChange={selectedItems => this.selectOption(item, selectedItems)}/>);
        });
        return (
            <div className="packageItemEdit">
                <div className="row table-bordered title">
                    <div className="name">
                        <h3>{this.props.packageSpec.name}</h3>
                        <h4>￥{this.props.price}</h4>
                    </div>
                    <img src={require("../../images/pos/closeTag.png")} className="pull-right closeBillItemEdit"/>
                </div>
                <div className="operateBox">
                    {items}
                </div>
                <div className="btn btn-lg btn-primary"
                     style={{margin: "30px 10px", backgroundColor: 'orange', borderColor: 'orange'}}
                     onClick={this.confirmOptions.bind(this)}>确认</div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/react/order/PackageBuilder.js